'use client';

import { useContext } from 'react';
import { ShareContext } from './Context';

export const useOpenShare = () => {
	const context = useContext(ShareContext);
	if (context === undefined) {
		throw new Error('useOpenShare must be used within a ShareProvider');
	}
	return context;
};
